{
  "back": "वापस",
  "form": "फ़ॉर्म",
  "purposeTitle": "आपके पड़ाव का उद्देश्य क्या है?",
  "appointmentInfoTitle": "अपॉइंटमेंट जानकारी",
  "appointmentInfoHint": "यदि आपके पास अपॉइंटमेंट है तो इस फ़ील्ड को अवश्य भरें।",
  "checkInDetailsTitle": "चेक-इन विवरण",
  "checkInDetailsHint": "आपकी यात्रा के बारे में अतिरिक्त जानकारी।",
  "driverPhoneLabel": "ड्राइवर का फ़ोन नंबर",
  "activateWhatsAppTitle": "WhatsApp मैसेजिंग सक्रिय करें",
  "activateWhatsAppBody": "वेयरहाउस से बात करने के लिए, जब हम आपको पहला WhatsApp संदेश भेजें तो \"OK\" जवाब दें।",
  "whatsappDelayBanner": "पहला WhatsApp संदेश आने में एक मिनट तक का समय लग सकता है।",
  "notesLabel": "नोट्स",
  "notesPlaceholder": "सुविधा के लिए कोई विशेष निर्देश या नोट्स?",
  "addNoteToWarehouse": "गोदाम के लिए नोट जोड़ें",
  "verifyAndCheckIn": "सत्यापित करें और चेक-इन करें",
  "completeCheckIn": "चेक-इन पूरा करें",
  "visitGroupInbound": "इनबाउंड",
  "visitGroupOutbound": "आउटबाउंड",
  "visitGroupBoth": "इनबाउंड और आउटबाउंड",
  "visitUnloadTruck": "मेरा ट्रक अनलोड करें",
  "visitDropTrailer": "मेरा ट्रेलर या कंटेनर छोड़ें",
  "visitLoadTruck": "मेरा ट्रक लोड करें",
  "visitHookTrailer": "एक ट्रेलर या कंटेनर हुक करें",
  "visitUnloadLoad": "मेरा ट्रक अनलोड और लोड करें",
  "visitDropHook": "एक ट्रेलर या कंटेनर छोड़ें और हुक करें",
  "containerTrailer": "ट्रेलर",
  "containerContainer": "कंटेनर",
  "containerOversized": "ओवरसाइज़्ड",
  "containerOther": "अन्य",
  "defaultReferenceName": "PO नंबर",
  "identifierSuffix": "{reference} या पुष्टि संख्या",
  "licenseOrDotRequired": "कृपया लाइसेंस प्लेट या DOT नंबर भरें",
  "appointmentNotFound": "हम आपका अपॉइंटमेंट नहीं खोज सके",
  "referenceNotFound": "कोई मेल खाती अपॉइंटमेंट नहीं मिली। संदर्भ संख्याएँ केस-संवेदनशील हैं।",
  "referenceCaseSensitiveHint": "संदर्भ संख्या केस-संवेदनशील है",
  "messaging": {
    "whatsappFailedTitle": "WhatsApp संदेश भेजने में असमर्थ",
    "smsFailedTitle": "SMS संदेश भेजने में असमर्थ",
    "whatsappFailedBody": "हम {displayPhone} पर संदेश नहीं भेज सके। <br /><br /> यदि आपने पहले सदस्यता रद्द की है, तो इस वेयरहाउस से संदेश प्राप्त करना शुरू करने के लिए <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> पर START टेक्स्ट करें।",
    "smsFailedBody": "हम {displayPhone} पर संदेश नहीं भेज सके। <br /><br /> यदि आपने पहले सदस्यता रद्द की है, तो इस वेयरहाउस से SMS संदेश प्राप्त करना शुरू करने के लिए <a href='{smsUrl}'>{senderPhone}</a> पर START टेक्स्ट करें।",
    "fallbackPhone": "प्रदान किया गया फ़ोन नंबर"
  }
}
